<div class="config-panel" [class.minimized]="isMinimized">
  <div class="panel-header">
    <h2 class="panel-title">{{ title }}</h2>
  </div>
  
  <div class="panel-content">
    <!-- 画像アップロードセクション -->
    <div class="upload-section">
      <h3 class="section-title">1. {{ imageUploadConfig.label }}</h3>
      <div class="image-upload-container">
        <input 
          type="file" 
          id="configImageUpload" 
          [accept]="imageUploadConfig.acceptTypes"
          (change)="onFileSelected($event)"
          class="file-input"
        >
        <label for="configImageUpload" class="upload-label" [class.has-image]="uploadedImage">
          <div class="upload-placeholder" *ngIf="!uploadedImage">
            <svg class="upload-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke-width="2"/>
              <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
              <path d="M21 15l-5-5L5 21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="upload-text">{{ imageUploadConfig.placeholder }}</p>
            <p class="upload-hint">{{ imageUploadConfig.hint }}</p>
            
            <div class="upload-buttons">
              <button type="button" class="upload-file-btn" onclick="document.getElementById('configImageUpload').click(); return false;">
                {{ i18n.t('configPanel.selectFile') }}
              </button>
              <button type="button" class="upload-drive-btn" (click)="openGoogleDriveSelector()">
                <img src="/assets/icon_google_drive.png" alt="Google Drive" class="drive-icon">
                {{ i18n.t('configPanel.selectFromDrive') }}
              </button>
            </div>
          </div>
          <div class="preview-wrapper" *ngIf="uploadedImage">
            <img [src]="uploadedImage" [alt]="imageUploadConfig.label" class="preview-image">
            <div class="image-overlay">
              <button class="change-btn" (click)="$event.preventDefault(); onFileRemove()">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>
          </div>
        </label>
      </div>
    </div>

    <!-- プロンプト入力セクション -->
    <div class="prompt-section">
      <h3 class="section-title">2. {{ promptConfig.label }}</h3>
      <textarea
        [(ngModel)]="promptValue"
        [placeholder]="promptConfig.placeholder"
        (input)="onPromptChange(promptValue)"
        class="prompt-textarea"
        [rows]="promptConfig.rows"
        [attr.maxlength]="promptConfig.maxLength || null"
      ></textarea>
    </div>

    <!-- カスタムセクション -->
    <ng-content select="[slot=custom-section]"></ng-content>

    <!-- 生成ボタン -->
    <button 
      class="generate-btn" 
      [disabled]="isGenerateDisabled"
      (click)="onGenerate()"
    >
      <span>{{ isProcessing ? buttonConfig.processingText : buttonConfig.defaultText }}</span>
    </button>
  </div>
</div>

<!-- Google Drive画像選択モーダル -->
<app-google-drive-image-selector
  [isOpen]="googleDriveSelectorOpen"
  [title]="i18n.t('configPanel.selectKeyVisual')"
  (imageSelected)="onGoogleDriveImageSelected($event)"
  (closed)="onGoogleDriveSelectorClosed()">
</app-google-drive-image-selector>